import posthog from "posthog-js";
import { APP_TO_BUILD } from "../../appsConfig";
import { redactPropertyBag } from "./analyticsRedaction";

const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY as string;
const POSTHOG_API_HOST =
  import.meta.env.VITE_POSTHOG_API_HOST || "https://app.posthog.com";

posthog.init(POSTHOG_API_KEY, {
  api_host: POSTHOG_API_HOST,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,

  session_recording: {
    // Default-deny. Learner emails, bulk-distribution recipient lists and
    // redemption codes are all typed into inputs in this app; recording them
    // would place a redeemable credential into replay storage. Note this must
    // be correct here — an explicit client value overrides the project-side
    // masking setting, so it cannot be repaired from the PostHog dashboard.
    maskAllInputs: true,
  },

  // Runs on every captured event before it is sent. `$set` and `$set_once`
  // matter as much as `properties`: PostHog persists those as person
  // properties, so a credential landing there outlives the event that carried
  // it and cannot be removed by deleting that event.
  //
  // Deliberately `before_send` rather than `sanitize_properties`: the latter is
  // deprecated in the installed version, logs an error on every event, and is
  // skipped entirely for session-replay `$snapshot` events.
  before_send: (captureResult) => {
    if (!captureResult) return captureResult;
    redactPropertyBag(captureResult.properties);
    redactPropertyBag(captureResult.$set);
    redactPropertyBag(captureResult.$set_once);
    return captureResult;
  },
});

/**
 * Wrapper function for posthog.capture that automatically includes attribution_app property
 * @param eventName - The name of the event to capture
 * @param properties - Optional additional properties to include with the event
 */
export const captureEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  posthog?.capture(eventName, {
    attribution_app: `${APP_TO_BUILD} - Web`,
    ...properties,
  });
};

export default posthog;
